<template>
    <a-input
        v-model="changeValue"
        :type="parameters.type"
        :clearable="parameters.clearable"
        :maxLength="maxLength"
        :class="{ 'input-word-limit': parameters.isShowMax && maxLength !== Infinity }"
        @blur="onBlur"
        :placeholder="parameters.placeholder"
    >
        <template v-if="parameters.isShowMax && maxLength !== Infinity" v-slot:suffix>
            <span style="opacity: 0.6">{{ `${changeValue.length}/${maxLength}` }}</span>
        </template>
    </a-input>
</template>

<script>
import { DataEntryMixin } from './mixins';

export default {
    name: 'SdInput',
    mixins: [DataEntryMixin],
    computed: {
        // 是否可编辑
        isModify({ $props }){
            return Boolean($props.field.isModify);
        },
        maxLength() {
            return this.parameters.maxLength || this.parameters.maxLength === 0
                ? this.parameters.maxLength < 128 || this.parameters.maxLength === 128
                    ? this.parameters.maxLength
                    : 128
                : Infinity;
        },
    },
    methods: {
        updateValue(e) {
            this.$emit('update:value', e.target.value);
        },
        onBlur() {
            this.$emit('onValidate');
        },
    },
};
</script>

<style scoped lang="less"></style>
